export default {"src":"/_next/static/media/iphone-old-send.59e9cd4d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};